import { AvatarBadge, StatusBadge } from '../ui';
import { s } from '../listPageStyles';
import { ViewIcon, EditIcon, DeleteIcon } from './icons';

const ACTION_ICON = { view: ViewIcon, edit: EditIcon, delete: DeleteIcon };

/**
 * c360 KART görünümü — paylaşılan standart (C360Table'ın kart kardeşi).
 * Prototip `.ccard`/`.cardgrid` tasarımını (sfa.css) kullanır; `.sfa` scope'unda render eder.
 *
 * Props:
 *   rows            — görüntülenecek satırlar (table.getRowModel().rows.map(r => r.original) ya da düz dizi)
 *   card(row)       — her satırı karta eşleyen fonksiyon → {
 *                        avatarName?, avatarTone?='customer',
 *                        title, subtitle?, statusTone?, statusLabel?,
 *                        meta?: [{ k, v }]   // etiket + değer satırları
 *                      }
 *   onCardClick(row), onCardDoubleClick(row)
 *   actions(row)    — kart aksiyon ikonları (liste "İşlemler" kolonunun karşılığı) →
 *                     [{ kind: 'view'|'edit'|'delete', onClick(row), title?, hidden? }]
 *                     hidden=true olan (ör. yetki yoksa) render edilmez.
 *   selectedId      — seçili satır id'si (kart vurgusu)
 *   loading, emptyText
 *
 * Kullanım (herhangi bir liste ekranı):
 *   {viewMode === 'card' && (
 *     <C360CardGrid rows={rows} card={rowToCard} onCardClick={setSelected}
 *                   onCardDoubleClick={openView} selectedId={selected?.id} loading={loading} />
 *   )}
 */
export function C360CardGrid({
  rows = [],
  card,
  actions,
  onCardClick,
  onCardDoubleClick,
  selectedId,
  loading = false,
  emptyText = 'Kayıt bulunamadı',
}) {
  return (
    <div className="c360-table-wrap sfa" style={{ position: 'relative' }}>
      <div className="cardgrid" style={{ padding: '4px 2px' }}>
        {rows.map((row) => {
          const c = card(row) || {};
          const acts = (actions ? actions(row) || [] : []).filter((a) => a && !a.hidden);
          return (
            <div
              key={row.id}
              className={`ccard${selectedId === row.id ? ' is-selected' : ''}`}
              onClick={() => onCardClick?.(row)}
              onDoubleClick={() => onCardDoubleClick?.(row)}
            >
              {c.statusTone && c.statusLabel && (
                <div className="ccard-badge"><StatusBadge tone={c.statusTone}>{c.statusLabel}</StatusBadge></div>
              )}
              <div className="ccard-head">
                {c.avatarName && <AvatarBadge name={c.avatarName} tone={c.avatarTone || 'customer'} size={42} />}
                <div style={{ minWidth: 0 }}>
                  <div className="nm" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.title || '-'}</div>
                  {c.subtitle && <div className="sub">{c.subtitle}</div>}
                </div>
              </div>
              {c.meta && c.meta.length > 0 && (
                <div className="ccard-meta">
                  {c.meta.map((m, i) => (
                    <span key={i}><span style={{ minWidth: 58, color: 'var(--t3)' }}>{m.k}</span>{m.v}</span>
                  ))}
                </div>
              )}
              {acts.length > 0 && (
                <div className="ccard-actions c360-actions">
                  {acts.map((a, i) => {
                    const Ic = ACTION_ICON[a.kind] || ViewIcon;
                    return (
                      <button
                        key={i}
                        type="button"
                        className={`c360-action-btn c360-action-btn--icon c360-action-btn--${a.kind}`}
                        title={a.title}
                        aria-label={a.title}
                        onClick={(e) => { e.stopPropagation(); a.onClick?.(row); }}
                      >
                        <Ic />
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
      {rows.length === 0 && (
        <div className="c360-kanban-empty">{loading ? 'Yükleniyor...' : emptyText}</div>
      )}
      {loading && rows.length > 0 && <div style={s.loadingOverlay}>Yükleniyor...</div>}
    </div>
  );
}
